<template>
  <header_m/>
  <Contact_index_m/>
  <Contact_page_m/>
  <Footer_m/>

</template>
<script>
import Contact_index from '../../components/CN/contact/Contact_index'
import Contact_page from "@/components/CN/contact/Contact_page";
import Footer from "@/components/CN/Footer";
import Contact_index_m from "@/components/CN_mobile/contact/Contact_index_m";
import Contact_page_m from "@/components/CN_mobile/contact/Contact_page_m";
import Header_m from "@/components/CN_mobile/Header_m";
import Footer_m from "@/components/CN_mobile/Footer_m";

export default {
  name: 'Contact_m',
  components: {
    Footer_m,
    Header_m,
    Contact_page_m,
    Contact_index_m,
    Footer,
    Contact_index,
    Contact_page,
  }
}
</script>
<style scoped>

</style>

